import { Button } from "@capacit-com/lara-law-shared-ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@capacit-com/lara-law-shared-ui";
import { Pill } from "@capacit-com/lara-law-shared-ui";
import { Permission } from "@/lib/permissions/Permission.enum";
import { useHasPermission } from "@/lib/permissions/permissionFunctions";
import { PermissionGate } from "@/lib/permissions/PermissionGate";
import { cn } from "@/lib/utils";
import Prompt, { PromptStatus } from "@/models/prompt/prompt";
import { User } from "@/models/users/User";
import { ChevronRight } from "lucide-react";
import { FC } from "react";

type PromptCardProps = {
  prompt: Prompt;
  user?: User;
  onClick: () => void;
};

const PromptCard: FC<PromptCardProps> = ({ prompt, user, onClick }) => {
  const hasPermission = useHasPermission();

  const userHasPermission = hasPermission({
    allOf: [Permission.UpdatePromptsApproval],
  });

  return (
    <Card
      className={cn(
        "h-full flex flex-col hover:shadow-[0px_6px_8px_-2px_rgba(0,0,0,0.1)] transition-shadow duration-200 rounded-lg",
        !userHasPermission && "cursor-not-allowed",
        userHasPermission && "cursor-pointer"
      )}
      onClick={userHasPermission ? onClick : undefined}
    >
      <CardHeader className="grow">
        <div className="space-y-2">
          <h3 className="font-semibold text-lg line-clamp-1">{prompt.title}</h3>
          {user && (
            <p className="text-sm text-muted-foreground">
              Oprettet af {user.firstName} {user.lastName}
            </p>
          )}
        </div>
      </CardHeader>
      <CardContent className="grow">
        <p className="text-sm text-muted-foreground line-clamp-3">
          {prompt.description}
        </p>
      </CardContent>
      <CardFooter className="flex flex-row justify-between ">
        <div className="flex flex-wrap gap-2 flex-row items-start">
          {prompt.tags.map((tag, tagIndex) => {
            return <Pill pillLabel={tag.name} index={tagIndex} />;
          })}
        </div>
        <PermissionGate allOf={[Permission.UpdatePromptsApproval]}>
          <Button
            variant="ghost"
            size="sm"
            className="text-sm"
            onClick={onClick}
          >
            {prompt.status === PromptStatus.Accepted ? "Se" : "Review"}
            <ChevronRight className="ml-1 size-4" />
          </Button>
        </PermissionGate>
      </CardFooter>
    </Card>
  );
};

export default PromptCard;
